/**
 * Onboarding Audit Events — IN-2.a
 * ────────────────────────────────
 * Append-only sink. Never edits, never deletes.
 */

import type { OnboardingAuditAction, OnboardingAuditEvent } from "./types";

let __seq = 0;
function nextId(): string {
  __seq += 1;
  return `oaud-${Date.now().toString(36)}-${__seq.toString(36)}`;
}

export interface AppendAuditInput {
  actor: string;
  action: OnboardingAuditAction;
  tokenId?: string;
  sessionId?: string;
  documentId?: string;
  reason?: string;
  metadata?: Record<string, unknown>;
}

export function appendAuditEvent(
  events: OnboardingAuditEvent[],
  input: AppendAuditInput,
): OnboardingAuditEvent[] {
  const actor = (input.actor ?? "").trim();
  if (!actor) {
    throw new Error("onboardingAudit: actor is required.");
  }
  if (!input.action) {
    throw new Error("onboardingAudit: action is required.");
  }
  const evt: OnboardingAuditEvent = {
    id: nextId(),
    at: new Date().toISOString(),
    actor,
    action: input.action,
    tokenId: input.tokenId,
    sessionId: input.sessionId,
    documentId: input.documentId,
    reason: input.reason,
    metadata: input.metadata,
  };
  return [...events, evt];
}
